export * from './lib/shared-core-storage';
